import Fullpage from "fullpage.js";
import { CountUp } from "countup.js";

//enable stimulus
import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Configure Stimulus development experience
application.warnings = true;
application.debug = false;
window.Stimulus = application;

export { application };
import "/controllers";

if (document.readyState !== "loading") {
  initializeFullPage();
} else {
  document.addEventListener("DOMContentLoaded", initializeFullPage);
}

function initializeFullPage() {
  const colors = ["no-color", "salmon", "yellow", "white", "blue-light", "blue-dark"];
  const topBar = document.getElementById("topbar");
  const navBar = document.getElementById("navbar");
  const fullPage = document.getElementById("fullpage");
  const loading = document.getElementById("loading");
  const mainComponent = document.getElementById("main-component");

  initializeCounters();

  new Fullpage(fullPage, {
    navigation: false,
    sectionsColor: ["transparent", "#fdf0e7", "#F6CB52", "#f7f7f7", "#102A6B", "#f7f7f7"],
    licenseKey: "B2A25FF5-F03440A9-86BAF0AA-E396F071",
    verticalCentered: true,
    controlArrows: false,
    loopHorizontal: false,
    autoScrolling: false,
    scrollBar: true,
    touchSensitivity: 20,

    afterLoad: (origin, destination) => {
      if (destination.anchor === "stats") {
        startCounters();
      }

      topBar.classList.remove(...colors);
      topBar.classList.add(colors[destination.index]);

      let activeLink = navBar.querySelector("a.active");
      if (activeLink) activeLink.classList.remove("active");

      activeLink = navBar.querySelector(`a[href="#${destination.anchor}"]`);
      if (activeLink) activeLink.classList.add("active");
    },
  });

  loading.classList.add("loading--hide");
  mainComponent.classList.add("loaded");
}

function startCounters() {
  window.userCounter.start();
  window.careProviderCounter.start();
}

function initializeCounters() {
  if (window.userCounter === undefined) {
    window.userCounter = initializeCounter("user-counter");
  }

  if (window.careProviderCounter === undefined) {
    window.careProviderCounter = initializeCounter("care-provider-counter");
  }
}

function initializeCounter(identifier) {
  const counter = document.getElementById(identifier);
  const count = parseInt(counter.innerHTML.replace(".", ""));

  return new CountUp(identifier, count, { separator: "." });
}
